import { DataService } from './data.service';
import { Component } from '@angular/core';

import { Platform, Events } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { Storage } from '@ionic/storage';
import { Router,NavigationExtras } from '@angular/router';
import { LoaderService } from './loder_service/loader.service';
import { Market } from '@ionic-native/market/ngx';
import { Push, PushObject, PushOptions } from '@ionic-native/push/ngx';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {
  user_name: any;
  user_id: any;

  category_name:any;
  user_images:any;
  public appPages = [
    {
      title: 'My Profile',
      url: '/profile',
      icon: 'home'
    },
    {
      title: 'Dashboard',
      url: '/dashboard',
      icon: 'list'
    },
    {
      title: 'Running Batches',
      url: '/runbatch',
      icon: 'list'
    },
    {
      title: 'Complete Batches',
      url: '/completebatch',
      icon: 'list'
    },
    {
      title: 'UpComing Batches',
      url: '/upcomingbatch',
      icon: 'list'
    },
    // {
    //   title: 'List',
    //   url: '/list',
    //   icon: 'list'
    // },
  ];

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    public storage:Storage,
    public router:Router,
    public toastService:LoaderService,
    public events:Events,
    private market:Market,
    public restApi:DataService,
    public push:Push,
    
  ) {
    this.initializeApp();
    this.events.subscribe('cart:updated', (count) => {
      console.log(count)
      this.user_name=count.user_name;
      this.category_name=count.category_name;
      this.user_images=count.user_images;
    });
    this.events.subscribe('cart:images', (images) => {
      console.log(images)
      this.user_images=images
    });
  }
ionViewWillEnter(){
  // this.storage.get('user_id').then((user_id) => { 
   
  //   if(user_id){
  //     this.router.navigate(['/selclass'])
  //   }else{
  //     this.router.navigate(['/login'])
  //   }
  // })

  this.user_id = localStorage.getItem('user_id');

  if(this.user_id){
        this.router.navigate(['/selclass'])
      }else{
        this.router.navigate(['/login'])
      }



}
  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.backgroundColorByHexString('#f3681d');
      // this.statusBar.styleDefault();
      this.splashScreen.hide();
      this.ionViewWillEnter()
      //this.saveDeviceToken();
      this.initPushNotification();
    });
  }
  signOut(){

    if(confirm(' Are you sure to exit ?')){
      localStorage.clear();
      this.router.navigate(['/login'])
      this.toastService.create('You have successfully logged out');
      // this.storage.remove('user_id')
      // this.storage.remove('user_name')
      // this.storage.remove('category_name')


    }
  
    
  }
  gotopremium(){
    let video_id=0;
    let navigationExtras: NavigationExtras = {
      queryParams: {
        id: JSON.stringify(video_id)
      }
    };
    this.router.navigate(['/upgrade'],navigationExtras)
  }
 // routerLink="/upgrade"

 showRatePrompt(){
  this.market.open('emc.student.com');
}
   //Push Notification
   saveDeviceToken(token)
   {
    
       let postparams={
         token:token,
       }
       this.restApi.savedevicetoken(postparams).subscribe((data:any)=>{
         //alert(JSON.stringify(data));
       },(error:any)=>{
         //alert(JSON.stringify(error));
       })
   
     //let token="hi";
 
 
 }
   initPushNotification()
   {
     // to check if we have permission
 this.push.hasPermission()
   .then((res: any) => {
 
     if (res.isEnabled) {
       console.log('We have permission to send push notifications');
     } else {
       console.log('We don\'t have permission to send push notifications');
     }
 
   });
 
 // to initialize push notifications
 
 const options: PushOptions = {
    android: {
        senderID: 'XXXXXXXXXXXXX'
    },
    ios: {
        alert: 'true',
        badge: true,
        sound: 'false'
    },
    windows: {}
 };
 
 const pushObject: PushObject = this.push.init(options);
 
 pushObject.on('notification').subscribe((notification: any) =>{
   console.log('Received a notification', notification);
 if(notification.message){
   //this.nav.push(NotificationPage)
 }
 
   //Notification Display Section
    /*let confirmAlert = this.alertCtrl.create({
           title: 'New Notification',
           message: JSON.stringify(notification),
           buttons: [{
             text: 'Ignore',
             role: 'cancel'
           }, {
             text: 'View',
             handler: () => {
               //TODO: Your logic here
               //self.nav.push(DetailsPage, {message: data.message});
             }
           }]
         });
         confirmAlert.present();*/
 
 });
 
 pushObject.on('registration').subscribe((registration: any) => {
   console.log('Device registered', registration);
   ///alert(JSON.stringify(registration));
 
   this.saveDeviceToken(registration.registrationId);
 });
 
 pushObject.on('error').subscribe(error => console.error('Error with Push plugin', error));
   }
 
}
